// Email Form Handling

// TODO: Remove following variables from global scope
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// TODO: Raise errors if elements can't be queried
const input = document.querySelector<HTMLInputElement>('.js-email-input')!;
if (input === null) { throw new Error('.js-email-input is null'); }
const errorMessage = document.querySelector('.js-email-form-error-message')!;
if (errorMessage === null) { throw new Error('.js-email-form-error-message element is null'); }
const successMessage = document.querySelector('.js-email-form-success-message')!;
if (successMessage === null) { throw new Error('.js-email-form-success-message element is null'); }
const submitBtn = document.querySelector('.js-email-form-submit-btn')!;
if (submitBtn === null) { throw new Error('.js-email-form-submit-btn element is null'); }
// TODO: Adjust how page data is set in the markdown
const rawPageData = document.getElementById('pageData');
if (rawPageData === null) { throw new Error('pageData element is null'); }
const pageData = JSON.parse(rawPageData.textContent);
const csrfToken = pageData.csrfToken;

function showSuccessMessage() {
    // TODO: Can this `querySelector` call be extracted out?
    const container = document.querySelector('.js-email-form-container');
    if (container === null) { throw new Error('.js-email-form-container element is null'); }
    container.classList.add('success');
    successMessage.classList.add('email-form__success-message--is-visible');
    submitBtn.classList.add('submit-btn--hidden');
}

// TODO: Focus `postFormData` on POST /email?
function postFormData(formData: FormData, endpoint: string) {
    return fetch(endpoint, {
        method: 'POST',
        body: formData,
    })
        .then((response) => {
            return response.json().then((data) => {
                const statusCode = response.status;
                // TODO: Extract out error message
                if (statusCode >= 200 && statusCode < 300) {
                    return { success: true };
                } else if (statusCode === 400) {
                    const error = data.error || {};
                    return { success: false, error };
                } else {
                    return { success: false, error: 'Something went wrong, please try again later.' };
                }
            });
        })
        .catch(() => {
            return { success: false, error: 'Something went wrong, please try again later.' };
        });
}

function handleEmailSubmission() {
    const formData = new FormData();
    const email = input.value;

    if (!email) {
        errorMessage.textContent = 'Please enter an email address';
    } else if (!emailRegex.test(email)) {
        errorMessage.textContent = 'Please enter a valid email address';
    } else {
        errorMessage.textContent = '';
        formData.append('email', email);
        formData.append('csrftoken', csrfToken);

        postFormData(formData, '/email').then((result) => {
            if (result.success) {
                showSuccessMessage();
            } else if (result.error) {
                errorMessage.textContent = result.error;
            } else {
                errorMessage.textContent = 'Something went wrong, please try again later.';
            }
        });
    }
}

// TODO: Move following `addEventListener` calls to an initialization function
// TODO: Create initialization function that supports multiple forms
submitBtn.addEventListener('click', handleEmailSubmission);
// TODO: Replace error function with a named function
input.addEventListener('input', () => {
    if (errorMessage.textContent.length > 0) {
        errorMessage.textContent = '';
    }
});
